import { createTooltipHTML } from '../trusted-types';

export const PriceChartTooltip = {
  mounted() {
    const tooltip = this.el.querySelector('.price-tooltip');
    const tooltipContent = this.el.querySelector('.tooltip-content');

    if (!tooltip || !tooltipContent) return;

    this.el.querySelectorAll('.price-hover-area').forEach((area) => {
      area.addEventListener('mouseenter', (e) => {
        const price = e.target.getAttribute('data-price');
        const date = e.target.getAttribute('data-date');
        const type = e.target.getAttribute('data-type');

        // Read geometry BEFORE writing innerHTML to avoid forced reflow
        const containerRect = this.el.getBoundingClientRect();
        const circleRect = e.target.getBoundingClientRect();

        const circleX = circleRect.left + circleRect.width / 2 - containerRect.left;
        const circleY = circleRect.top - containerRect.top;

        tooltipContent.innerHTML = createTooltipHTML({
          price,
          date,
          type
        });

        // Position with CSS transform to avoid forced reflow from offsetWidth/offsetHeight reads
        tooltip.style.left = `${circleX}px`;
        tooltip.style.top = `${circleY}px`;
        tooltip.classList.add('active');

        const typeLabel = type === 'forecast' ? ' (Forecast)' : '';
        area.setAttribute('title', `£${price} - ${date}${typeLabel}`);
      });

      area.addEventListener('mouseleave', () => {
        tooltip.classList.remove('active');
      });
    });
  }
};
